module.exports = __webpack_public_path__ + "img/mermaid_mans_catchphrase.6a8e80d3.jpg";